import { mapConfig } from 'lib/config'

let geolocationId: number | undefined = undefined

export function requestGeolocation(): Promise<GeolocationPosition> {
  const {
    geolocation: {
      requestCacheMaxAge: maximumAge,
      requestTimeout: timeout,
      requestWithHighAccuracy: enableHighAccuracy,
    },
  } = mapConfig

  const options: PositionOptions = {
    enableHighAccuracy,
    maximumAge,
    timeout,
  }

  return new Promise((resolve, reject) => {
    if (geolocationId !== undefined) {
      navigator.geolocation.clearWatch(geolocationId)
      geolocationId = navigator.geolocation.watchPosition(resolve, reject, options)
    } else {
      geolocationId = navigator.geolocation.watchPosition(resolve, reject, options)
    }
  })
}
